import React, { useState, useEffect } from "react";
import '../styles/components/travels/travelCard.scss';
import { Accordion, Carousel, Container } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { useCommonApi } from "../_common/hooks/api/common/commonApiHook";
import { useAppLoader } from "../_common/hooks/common/appLoaderHook";
import Header from "../components/header";
import parse from 'html-react-parser';
import LeftPanel from "../components/leftPanel";
import { IMAGE_ASSETS } from "../assets";

export default function CityInfo() {

    const { id } = useParams()
    const commonApi = useCommonApi()
    const { showLoader, hideLoader } = useAppLoader()

    const [cityId, setCityId] = useState<string>("")
    const [details, setDetails] = useState<any>(null)

    const getCityInfo = () => {
        showLoader()
        commonApi.getCityInfo({ city: cityId },
            (message: string, resp: any) => {
                console.log({ resp })
                setDetails(resp)
                hideLoader()
            }, (message: any) => {
                console.log({ message })
                hideLoader()
            })
    }

    useEffect(() => {
        if (id) {
            setCityId(id)
        }
    }, [id])

    useEffect(() => {
        if (cityId != "") {
            getCityInfo()
        }
    }, [cityId])

    return (
        <React.Fragment>
            <Header />
            <Container>
                <div className="wrapper-left-right-panel">
                    <LeftPanel img={IMAGE_ASSETS.travelSuitcases} text={"If you need Consular assistance whilst abroad, you can contact the Consular Section of the South African Diplomatic Mission in the country directly."} />
                    {details ?
                        <div className="dashboard">
                            <Container className="dashboard-container">
                                <div className="main-div travelcity-listinfo">
                                    <h2>{details?.Name}</h2>
                                    <div className="city-country-scroll-view">
                                        <div className="cityinfo_image">
                                            {details?.Images && details?.Images.length > 0 ?
                                                <Carousel className="details-carousal">
                                                    {details?.Images.map((item: any, i: number) => (
                                                        <Carousel.Item key={i}>
                                                            <img
                                                                className="d-block w-100"
                                                                src={item}
                                                                alt="First slide"
                                                            />
                                                        </Carousel.Item>
                                                    ))}
                                                </Carousel>
                                                : null
                                            }
                                        </div>
                                        <Accordion defaultActiveKey={['0', '1', '2', '3']}>
                                            <Accordion.Item eventKey="0">
                                                <Accordion.Header><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"></path></svg></span>General Information</Accordion.Header>
                                                <Accordion.Body>
                                                    <div className="accordian_listtxt">
                                                        <ul>
                                                            <li><b>Country name: </b><span>{details?.Name}</span></li>
                                                            <li><b>Police station: </b><span>{details?.PoliceStation}</span></li>
                                                            <li><b>Head of mission: </b><span>{details?.HeadOfMission}</span></li>
                                                        </ul>
                                                    </div>

                                                </Accordion.Body>
                                            </Accordion.Item>
                                            <Accordion.Item eventKey="1">
                                                <Accordion.Header><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"></path></svg></span>Crime News</Accordion.Header>
                                                <Accordion.Body>
                                                    {details && details?.CrimeNews ? parse(details?.CrimeNews) : null}
                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="2">
                                                <Accordion.Header><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"></path></svg></span>Cultural Information</Accordion.Header>
                                                <Accordion.Body>
                                                    {details && details?.CulterInformation ? parse(details?.CulterInformation) : null}
                                                </Accordion.Body>
                                            </Accordion.Item>

                                            <Accordion.Item eventKey="3">
                                                <Accordion.Header><span><svg stroke="currentColor" fill="currentColor" strokeWidth="0" viewBox="0 0 24 24" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M19 11h-6V5h-2v6H5v2h6v6h2v-6h6z"></path></svg></span>Do's And Don't</Accordion.Header>
                                                <Accordion.Body>
                                                    {details && details?.DoAndDont ? parse(details?.DoAndDont) : null}
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </Accordion>
                                    </div>
                                    <Link className="btn btn-success mt-2" to="/country-directory">Back</Link>
                                </div>
                            </Container>
                        </div>
                        : null
                    }
                </div>
            </Container>
        </React.Fragment>

    )
}